import { useEffect, useState } from "react";
import { useGlobalContext } from "../Context/GlobalContext";
import { useNavigationContext } from "../Context/NavigationContext";
import { motion } from "motion/react"

const LandingView = () => {
    const { dbManager, getThemeImage } = useGlobalContext();
    const { 
        landingView, 
        showScience,  
        entering, 
        navigateTo, 
        setEntering, 
        changeLandingView,
    } = useNavigationContext();
    const [frameHeight, setFrameHeight] = useState<string>('90%');
    const [frameWidth, setFrameWidth] = useState<string>('92%');
    const [showFrame, setShowFrame] = useState<boolean>(false);
    const [scale, setScale] = useState<number>(1);
    const [opacity, setOpacity] = useState<number>(1);
    const [loaded, setLoaded] = useState<boolean>(false);
    const [startedEnter, setStartedEnter] = useState<boolean>(false);

    useEffect(() => {
        const handleStart = async () => {
            if(dbManager.isAuthenticated()) {
                changeLandingView('terminal');
            } else {
                changeLandingView('login');
            }
            setLoaded(true);
        }
        handleStart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const runAnimation = () => {
            setStartedEnter(true)
            setShowFrame(true);
            setFrameHeight('0px');
            
            setTimeout(() => {
                setFrameWidth('0px');
            }, 120);

            setTimeout(() => {
                setScale(3);
                setOpacity(0);          
            }, 100);

            setTimeout(() => {
                setEntering(false);
                navigateTo('dashboard');
            }, 500);
        }

        if(!startedEnter && entering) runAnimation()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [entering]);

    const SideScience = () => {
        return <img className="science-side-img" src={getThemeImage("UNKONVENT_SCIENCE_rotate")} alt="science"/>
    }

    return (
        <motion.div className="landing-container" initial={{ scale: 1, opacity: 1 }} animate={{ scale: scale, opacity: opacity }} transition={{ duration: 1 }}>
            <div className="landing">
                <div>
                    <motion.div 
                        className="turn-off"
                        initial={{ height: '90%', width: '92%', display: 'none' }} 
                        animate={{ height: frameHeight, width: frameWidth, display: showFrame ? 'block' : 'none' }} 
                        transition={{ duration: 0.2 }}
                        style={{
                            backgroundColor: 'white', 
                            zIndex: 210, 
                            position: 'absolute', 
                            top: '50%',        
                            left: '50%',       
                            transform: 'translate(-50%, -50%)',
                            borderRadius: '50px',
                            transformOrigin: 'center'
                        }}
                    ></motion.div>
                </div>
                {!entering && showScience && <SideScience />}
                <img src="/assets/Screen_outer.png" alt="Outer Screen" className="screen-outer" draggable="false"/>
                <img src="/assets/Screen_inner.png" alt="Inner Screen" className="screen-inner" draggable="false"/>
                {!entering && <div className="tv-content">
                    <div className="tv-content-wrapper">
                        {loaded && landingView}
                    </div>
                </div>}          
            </div>
        </motion.div>
    );
}

export default LandingView;